import { validateRedirectUrl } from './validate-redirect';

const KEY = 'auth_redirect_url';

// Cognito returns social sign-ins to /redirect without the ?redirect= query
export function saveOAuthRedirect(search: string) {
  const to = validateRedirectUrl(new URLSearchParams(search).get('redirect'));
  if (to === '/redirect') {
    sessionStorage.removeItem(KEY);
  } else {
    sessionStorage.setItem(KEY, to);
  }
}

export function takeOAuthRedirect(): string | null {
  const raw = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  const to = validateRedirectUrl(raw);
  return to === '/redirect' ? null : to;
}
